module.exports = __webpack_public_path__ + "img/qhdx.6d565583.png";